// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__Z1v9D","label":"styles_label__hNP16","icon":"styles_icon__sezH0"};